import { render, staticRenderFns } from "./homePage.vue?vue&type=template&id=2495b9b6&scoped=true"
import script from "./homePage.vue?vue&type=script&lang=js"
export * from "./homePage.vue?vue&type=script&lang=js"
import style0 from "./homePage.vue?vue&type=style&index=0&id=2495b9b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2495b9b6",
  null
  
)

export default component.exports